import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=03dbdded&scoped=true"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"
import style0 from "./Timestamp.vue?vue&type=style&index=0&id=03dbdded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbdded",
  null
  
)

export default component.exports